<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="requisitionType"
          :value.sync="queryParams.requisitionType"
          selectType="selectFilter"
          :selectData="requisitionTypeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="requisitionStatus"
          :value.sync="queryParams.requisitionStatus"
          selectType="selectFilter"
          :selectData="moStatusList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="returnType"
          :value.sync="queryParams.returnType"
          selectType="selectFilter"
          :selectData="returnTypeList"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiMesRequisitionExport" ref="download" />
        <a-button type="primary" v-if="$hasPermi(['mes:mesDiscreteJobsCcMo:cutBedExport'])" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" :scroll="{ fixScreen: true, x: 1300 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <div slot="operation" slot-scope="{ text, record }">
            <a @click="handleDetail(record, 'get')">已领明细</a>
            <a @click="handleDetail(record, 'return')" class="ml10">退料明细</a>
          </div>
        </ls-api-table>
        <labelDetailModal ref="labelDetailModalRef" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import { apiMesQueryRequisitionList, apiMesRequisitionExport } from '@/api/report/ordinary-report'
import labelDetailModal from './components/label-detail-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import moment from 'moment'

export default {
  name: 'CuttingBedGetOrReturnReport',
  components: { DownloadModal, labelDetailModal },
  mixins: [cacheRequest],
  data() {
    return {
      apiMesRequisitionExport,
      requisitionTypeList: [],
      moStatusList: [],
      returnTypeList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMesQueryRequisitionList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        wipEntityNameVal: undefined,
        moTicketCodeVal: undefined,
        requisitionCodeVal: undefined,
        requisitionType: undefined,
        itemCodeVal: undefined,
        requisitionStatus: undefined,
        returnKeyVal: undefined,
        returnType: undefined,
        requisitionTime: undefined,
        staRequisitionTime: undefined,
        endRequisitionTime: undefined,
        returnTime: undefined,
        staReturnTime: undefined,
        endReturnTime: undefined
      },
      formList: [
        { label: 'MO号', decorator: ['wipEntityNameVal'], type: 'input' },
        { label: 'MO票号', decorator: ['moTicketCodeVal'], type: 'input' },
        { label: '领料单号', decorator: ['requisitionCodeVal'], type: 'input' },
        { label: '领料类型', decorator: ['requisitionType'], type: 'requisitionType' },
        { label: '物料编码', decorator: ['itemCodeVal'], type: 'input' },
        { label: '领料状态', decorator: ['requisitionStatus'], type: 'requisitionStatus' },
        { label: '退料单号', decorator: ['returnKeyVal'], type: 'input' },
        { label: '退料类型', decorator: ['returnType'], type: 'returnType' },
        {
          label: '领料申请时间',
          type: 'range',
          decorator: ['requisitionTime'],
          disposeFormat: {
            staRequisitionTime: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endRequisitionTime: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        {
          label: '退料申请时间',
          type: 'range',
          decorator: ['returnTime'],
          disposeFormat: {
            staReturnTime: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endReturnTime: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: 'MO号', dataIndex: 'wipEntityName', align: 'center', width: 140 },
        { title: 'MO票号', dataIndex: 'moTicketCode', align: 'center', width: 130 },
        { title: 'MO状态', dataIndex: 'moStatusName', align: 'center', width: 100 },
        { title: '计划数量', dataIndex: 'planQuantity', align: 'center', width: 80 },
        { title: '领料单号', dataIndex: 'requisitionCode', align: 'center', width: 140 },
        { title: '出库单号', dataIndex: 'deliveryKey', align: 'center', width: 140 },
        { title: '领料类型', dataIndex: 'requisitionTypeName', align: 'center', width: 120 },
        { title: '领料状态', dataIndex: 'requisitionStatusName', align: 'center', width: 100 },
        { title: '领料申请时间', dataIndex: 'requisitionApplyTime', align: 'center', width: 140 },
        { title: '领料申请人', dataIndex: 'requisitionApplyUser', align: 'center', width: 90 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 100 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 120 },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 160, ellipsis: true },
        { title: '标准用量', dataIndex: 'quantityPerAssembly', align: 'center', width: 90 },
        { title: '本单需求量', dataIndex: 'requiredQuantity', align: 'center', width: 90 },
        { title: '合并需求数量', dataIndex: 'mergedRequiredQuantity', align: 'center', width: 100 },
        { title: '申请领料数量', dataIndex: 'requisitionQuantity', align: 'center', width: 100 },
        { title: '已领数量', dataIndex: 'receivedQuantity', align: 'center', width: 90 },
        { title: '退料单号', dataIndex: 'returnKey', align: 'center', width: 90 },
        { title: '退料类型', dataIndex: 'returnType', align: 'center', width: 90 },
        { title: '退料申请数', dataIndex: 'returnApplyQuantity', align: 'center', width: 90 },
        { title: '退料数量', dataIndex: 'returnedQuantity', align: 'center', width: 90 },
        { title: '退料申请时间', dataIndex: 'returnApplyTime', align: 'center', width: 140 },
        { title: '配送时间', dataIndex: 'deliveryDate', align: 'center', width: 140 },
        { title: '生产批次', dataIndex: 'lotNumber', align: 'center', width: 90 },
        { title: '是否让步', dataIndex: 'attr18', align: 'center', width: 90 },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 90 },
        { title: '父级工单号', dataIndex: 'upstreamWorkNumber', align: 'center', width: 90 },
        { title: '工作中心', dataIndex: 'workCenterName', align: 'center', width: 90 },
        { title: '班组', dataIndex: 'teamGroupName', align: 'center', width: 90 },
        {
          title: '操作',
          width: 140,
          dataIndex: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MES_CC_REQUISITION_TYPE', { lookupType: 'MES_CC_REQUISITION_TYPE', current: 1, pageSize: 999 }, 'requisitionTypeList')
    this.cacheLookupRequest('MES_CC_REQUISITION_STATUS', { lookupType: 'MES_CC_REQUISITION_STATUS', current: 1, pageSize: 999 }, 'moStatusList')
    this.cacheLookupRequest('MES_CC_RETURN_CAUSE', { lookupType: 'MES_CC_RETURN_CAUSE', current: 1, pageSize: 999 }, 'returnTypeList')
  },
  mounted() {
    this.$refs.refSearchForm.form.setFieldsValue({ requisitionTime: [moment(), moment()] })
    this.onSearch(
      {
        staReturnTime: moment().format('YYYY-MM-DD 00:00:00'),
        endReturnTime: moment().format('YYYY-MM-DD 23:59:59')
      }
    )
  },
  methods: {
    // 表单搜索
    onSearch(value = {}) {
      this.onChangeCopyFormExcel('wipEntityName', 'wipEntityNameList', value)
      this.onChangeCopyFormExcel('moTicketCode', 'moTicketCodeList', value)
      this.onChangeCopyFormExcel('requisitionCode', 'requisitionCodeList', value)
      this.onChangeCopyFormExcel('itemCode', 'itemCodeList', value)
      this.onChangeCopyFormExcel('returnKey', 'returnKeyList', value)
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(valField, listField, val) {
      const listVal = []
      if (val[valField + 'Val']) {
        const list = val[valField + 'Val'].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      if(listVal?.length > 1) {
        val[listField] = listVal
        delete val[valField]
      } else {
        val[valField] = listVal[0]
        delete val[listField]
      }
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        wipEntityNameVal: undefined,
        moTicketCodeVal: undefined,
        requisitionCodeVal: undefined,
        requisitionType: undefined,
        itemCodeVal: undefined,
        requisitionStatus: undefined,
        returnKeyVal: undefined,
        returnType: undefined,
        requisitionTime: undefined,
        staRequisitionTime: undefined,
        endRequisitionTime: undefined,
        returnTime: undefined,
        staReturnTime: undefined,
        endReturnTime: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 详情按钮
    handleDetail(row, type) {
      this.$refs.labelDetailModalRef.show(row.requisitionDetailId, type)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
